export const endpoints = {
    getSearchResults: '/api/omnia/v1/search/{searchTerm}',
    getMoviexchangeId: '/api/omnia/v1/home-cinema/{moviexchangeId}',
    getJournals: '/api/omnia/v1/journal/search/?{params}',
    getSubscriptions: '/api/omnia/v1/subscriptions',
    getFilmExtensions: '/api/omnia/v1/films/{filmId}',
}
